import { makeHttpRequest } from "@/shared";

import { mapCalculatedRepairFromServer } from "./mappers/mapCalculatedRepairFromServer";
import { mapRepairAdditionalServiceToServer } from "./mappers/mapRepairAdditionalServiceToServer";
export const addRepairAdditionalService = async (sessionKey, service) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/builder/${sessionKey}/add/service/additional`,
            method: "PUT",
            data: mapRepairAdditionalServiceToServer(service),
        })
    ).data;

    return mapCalculatedRepairFromServer(response.data);
};
